export const sameWidth = {
  name: "sameWidth",
  enabled: true,
  phase: "beforeWrite",
  requires: ["computeStyles"],
  fn: ({ state }) => {
    state.styles.popper.width = `${state.rects.reference.width}px`;
  }
};

export const fallbackPosition = {
  name: "flip",
  enabled: true,
  phase: "main",
  options: {
    fallbackPlacements: ["top-start"],
    altBoundary: true
  }
};
